export default __webpack_public_path__ + "static/media/How it works.2321dc1b.svg";